import * as React from 'react';

export default function ArrowIcon() {
  return (
    <svg className='svg-icon' width="44" height="23" viewBox="0 0 44 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M43.5607 12.5607C44.1464 11.9749 44.1464 11.0251 43.5607 10.4393L34.0147 0.893398C33.4289 0.307611 32.4792 0.307611 31.8934 0.893398C31.3076 1.47919 31.3076 2.42893 31.8934 3.01472L40.3787 11.5L31.8934 19.9853C31.3076 20.5711 31.3076 21.5208 31.8934 22.1066C32.4792 22.6924 33.4289 22.6924 34.0147 22.1066L43.5607 12.5607ZM0.5 13H42.5V10H0.5V13Z"/>
    </svg>
  )
}